import React from "react";
// CSS
import './css/button.css';
import './css/flexboxgrid.min.css';
import './css/jquery.fullpage.css';
import './css/typography.css';
import './css/animate.css';
// LIBS
import Reboot from 'material-ui/Reboot';
// UI
import Navbar from './components/ui/Navbar.js';
// Sections
import Intro from './components/sections/Intro.js';
import About from './components/sections/About.js';
import Auto from './components/sections/Auto.js';
import Train from './components/sections/Train.js';
import Plane from './components/sections/Plane.js';
import Hyperloop from './components/sections/Hyperloop.js';
import Ending from './components/sections/Ending.js';

import { Switch, Route } from 'react-router-dom'

// Libs
import $ from 'jquery';
import fullpage from 'fullpage.js';
import './../node_modules/fullpage.js/dist/jquery.fullpage.extensions.min.js';
import './jslib/fp-functions.js';


import svg4everybody from '../node_modules/svg4everybody/dist/svg4everybody.js';

svg4everybody();

require('./css/main.css');
require('./css/media.css');


export default class App extends React.Component
{
  render() {
    return (
      <Reboot>
    <div id='App'>
          <Navbar />
          <div id='fullpage'>
            <Intro />
            <About />
    				<Auto  />
    				<Train />
    				<Plane />
    				<Hyperloop />
            <Ending />
          </div>
          </div>
        </Reboot>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js